import { render, staticRenderFns } from "./_ViewNew.vue?vue&type=template&id=1025c3c7"
import script from "./_ViewNew.vue?vue&type=script&lang=js"
export * from "./_ViewNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports